<template>
  <q-item
    clickable
    dense
    class="text-green-8 ellipsis"
  >
    <q-item-section side>
      <q-icon :name="menuOpen ? 'mdi-chevron-up' : 'mdi-chevron-down'" />
    </q-item-section>
    <q-item-section>{{ broker.botName }}</q-item-section>

    <q-menu
      fit
      @before-show="menuOpen = true"
      @before-hide="menuOpen = false"
    >
      <q-list dense>
        <template v-for="template in templates">
          <q-separator :key="`temp-${template.id}`" />
          <q-item
            dense
            clickable
            v-close-popup
            :key="template.id"
            @click="$emit('on-handler-template-click', getTemplate(template))"
          >
            <q-item-section class="label q-pl-sm text-primary">
              <q-item-label
                lines="1"
                class="ellipsis"
              >
                {{ template.displayName }}
              </q-item-label>
            </q-item-section>

            <q-tooltip
              anchor="top left"
              self="top right"
              :offset="[3, -5]"
              max-width="250px"
            >
              <div class="title">
                <span>{{ template.displayName }}</span>
              </div>

              <div>
                {{ bodyMessage(template) }}
              </div>
            </q-tooltip>
          </q-item>
        </template>
      </q-list>
    </q-menu>
  </q-item>
</template>

<script>
import { sanitizeName } from '@/components/utils/sanitizeName'

export default {
  props: {
    broker: {}
  },

  data () {
    const menuOpen = false
    return { menuOpen }
  },

  computed: {
    templates () {
      const list = Array.isArray(this.broker?.templates) ? this.broker.templates : []
      return list.map(t => ({ ...t, displayName: sanitizeName(t.name) }))
    }
  },

  methods: {
    bodyMessage (template) {
      try {
        const cfg = JSON.parse(template.message)
        let data = '<span>'
        if (cfg.header) data += `<strong>${cfg.header}</strong><br /><br />`
        if (cfg.data) data += `${cfg.data}`
        if (cfg.footer) data += `<br /><strong>${cfg.footer}</strong>`
        if (cfg.buttons?.length) data += `<br /><br />${cfg.buttons.map(({ text }) => `<button>${text}</button>`).join('&nbsp;')}`
        data += '</span>'
        for (const param of template.params) {
          data = data.replaceAll(param.name, `<strong>*${param.value}*</strong>`)
        }

        return data
      } catch {
        return template.message
      }
    },

    getTemplate (item) {
      const template = { ...item }
      template.broker = { ...this.broker }
      delete template.broker.templates
      return template
    }
  }
}
</script>
